import { Chip } from '@mui/material';

interface RoleChipProps {
  roleName: string;
  size?: 'small' | 'medium';
}

/**
 * RoleChip - Display role with color coding
 * Super Admin = red, Admin = orange, Support = blue, Viewer = gray
 */
export const RoleChip = ({ roleName, size = 'small' }: RoleChipProps) => {
  const getRoleColor = (role: string): string => {
    const roleLower = role.toLowerCase();
    if (roleLower.includes('super') || roleLower === 'superadmin') {
      return '#f44336'; // red
    }
    if (roleLower === 'admin') {
      return '#ff9800'; // orange
    }
    if (roleLower === 'support') {
      return '#2196f3'; // blue
    }
    if (roleLower === 'viewer') {
      return '#9e9e9e'; // gray
    }
    return '#90caf9'; // default primary
  };

  return (
    <Chip
      label={roleName}
      size={size}
      sx={{
        backgroundColor: getRoleColor(roleName),
        color: '#fff',
        fontWeight: 'bold',
      }}
    />
  );
};
